<mat-progress-bar class="progress-bar" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<mat-card class="profile">
    <nrwl-user-info></nrwl-user-info>
    <nrwl-roles-groups></nrwl-roles-groups>
    <nrwl-user-security></nrwl-user-security>
    <nrwl-user-preferences [showAlertsPreference]="showAlertsPreference" [showThemePreference]="showThemePreference">
    </nrwl-user-preferences>
</mat-card>